// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ScheduledVideos admin page styles */

.scheduled-videos-page {
    padding: 0;
}

/* ── Header ── */
.sv-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.sv-header-left {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.sv-header h1 {
    margin: 0;
}

.sv-btn-refresh {
    padding: 0.5rem 1rem;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
    font-size: 0.85rem;
    transition: background 0.15s;
}

.sv-btn-refresh:hover {
    background: #f1f5f9;
}

/* ── Live indicator ── */
.sv-live-indicator {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.25rem 0.6rem;
    background: #ecfdf5;
    border: 1px solid #a7f3d0;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    color: #065f46;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.sv-live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #10b981;
    animation: sv-pulse 1.5s ease-in-out infinite;
}

@keyframes sv-pulse {

    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.5;
        transform: scale(0.8);
    }
}

/* ── Stats row ── */
.sv-stats-row {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.sv-stat-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 1.1rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
}

.sv-stat-value {
    font-size: 1.7rem;
    font-weight: 700;
    color: #1e293b;
}

.sv-stat-label {
    font-size: 0.75rem;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.sv-stat-published .sv-stat-value {
    color: #16a34a;
}

.sv-stat-pipeline .sv-stat-value {
    color: #2563eb;
}

.sv-stat-failed .sv-stat-value {
    color: #dc2626;
}

.sv-stat-today .sv-stat-value {
    color: #7c3aed;
}

/* ── Filters ── */
.sv-filters {
    display: flex;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
    align-items: flex-end;
}

.sv-select {
    padding: 0.5rem 0.75rem;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 0.9rem;
    background: #fff;
    min-width: 180px;
}

.sv-search-input {
    padding: 0.5rem 0.75rem;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 0.9rem;
    background: #fff;
    min-width: 260px;
    flex: 1 1 260px;
}

.sv-search-input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.sv-date-filters {
    display: flex;
    gap: 0.5rem;
    align-items: flex-end;
}

.sv-date-label {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    font-size: 0.75rem;
    color: #64748b;
}

.sv-date-label input[type="date"] {
    padding: 0.45rem 0.6rem;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 0.85rem;
}

/* ── Table ── */
.sv-table-container {
    background: #fff;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    overflow-x: auto;
}

.sv-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.88rem;
}

.sv-table thead th {
    text-align: left;
    padding: 0.75rem 0.85rem;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    color: #475569;
    font-weight: 600;
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    white-space: nowrap;
}

.sv-th-sortable {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.sv-th-sortable:hover {
    color: #1e293b;
}

.sv-table tbody td {
    padding: 0.65rem 0.85rem;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: middle;
}

.sv-row-clickable {
    cursor: pointer;
    transition: background 0.12s;
}

.sv-row-clickable:hover {
    background: #f8fafc;
}

.sv-cell-id {
    font-weight: 600;
    color: #64748b;
    font-size: 0.8rem;
}

.sv-cell-script {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #475569;
    font-size: 0.85rem;
}

.sv-user-cell {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}

.sv-user-email {
    font-size: 0.85rem;
    color: #475569;
}

.sv-ig-username {
    font-size: 0.75rem;
    color: #94a3b8;
}

.sv-has-video {
    font-size: 1.1rem;
}

.sv-no-video {
    color: #cbd5e1;
}

/* ── Platform icons in table ── */
.sv-platforms-cell {
    display: flex;
    gap: 0.35rem;
    align-items: center;
}

.sv-platform-icon {
    font-size: 1rem;
    text-decoration: none;
    opacity: 0.5;
    transition: opacity 0.15s;
}

.sv-platform-icon.sv-platform-ok {
    opacity: 1;
}

.sv-platform-icon.sv-platform-fail {
    opacity: 0.8;
    filter: grayscale(0.6);
}

a.sv-platform-icon:hover {
    opacity: 1;
    transform: scale(1.15);
}

/* ── Status badges ── */
.sv-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.2rem 0.55rem;
    border-radius: 6px;
    font-size: 0.73rem;
    font-weight: 600;
    white-space: nowrap;
}

.sv-badge-icon {
    font-size: 0.7rem;
}

.sv-status-draft {
    background: #f1f5f9;
    color: #475569;
}

.sv-status-pipeline {
    background: #dbeafe;
    color: #1e40af;
    animation: sv-badge-pulse 2s ease-in-out infinite;
}

.sv-status-pending {
    background: #fef3c7;
    color: #92400e;
}

.sv-status-approved {
    background: #e0f2fe;
    color: #0c4a6e;
}

.sv-status-queued {
    background: #fef3c7;
    color: #78350f;
}

.sv-status-published {
    background: #d1fae5;
    color: #065f46;
}

.sv-status-partial {
    background: #fef9c3;
    color: #713f12;
}

.sv-status-failed {
    background: #fee2e2;
    color: #991b1b;
}

@keyframes sv-badge-pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.7;
    }
}

/* ── Pagination ── */
.sv-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 1.25rem;
}

.sv-pagination button {
    padding: 0.4rem 0.9rem;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    font-size: 0.85rem;
}

.sv-pagination button:disabled {
    opacity: 0.45;
    cursor: default;
}

.sv-page-info {
    font-size: 0.85rem;
    color: #64748b;
}

/* ── States ── */
.sv-loading,
.sv-empty {
    text-align: center;
    padding: 3rem 1rem;
    color: #64748b;
    font-size: 0.95rem;
}

.sv-error {
    background: #fef2f2;
    color: #b91c1c;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
    font-size: 0.9rem;
}

/* ── Detail Modal ── */
.sv-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 1000;
    padding: 2rem 1rem;
    overflow-y: auto;
}

.sv-modal-card {
    background: #fff;
    border-radius: 12px;
    width: 100%;
    max-width: 700px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    margin: auto;
}

.sv-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #e2e8f0;
}

.sv-modal-header h2 {
    margin: 0;
    font-size: 1.1rem;
}

.sv-modal-close {
    background: none;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    color: #64748b;
    padding: 0.25rem;
}

.sv-modal-header-actions {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.sv-btn-delete {
    background: #fef2f2;
    color: #dc2626;
    border: 1px solid #fecaca;
    border-radius: 6px;
    padding: 0.35rem 0.75rem;
    font-size: 0.82rem;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
}

.sv-btn-delete:hover {
    background: #fee2e2;
    border-color: #f87171;
}

.sv-delete-confirm {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.sv-delete-confirm-text {
    font-size: 0.8rem;
    color: #dc2626;
    font-weight: 500;
}

.sv-btn-delete-yes {
    background: #dc2626;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 0.3rem 0.75rem;
    font-size: 0.8rem;
    cursor: pointer;
    font-weight: 600;
    transition: background 0.2s;
}

.sv-btn-delete-yes:hover {
    background: #b91c1c;
}

.sv-btn-delete-yes:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.sv-btn-delete-no {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    padding: 0.3rem 0.75rem;
    font-size: 0.8rem;
    cursor: pointer;
    transition: background 0.2s;
}

.sv-btn-delete-no:hover {
    background: #e2e8f0;
}

.sv-modal-body {
    padding: 1.5rem;
}

.sv-detail-status-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
}

.sv-detail-status-msg {
    font-size: 0.85rem;
    color: #64748b;
    font-style: italic;
}

.sv-detail-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.sv-detail-item {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
}

.sv-detail-item label {
    font-size: 0.72rem;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.sv-detail-item span {
    font-size: 0.9rem;
    color: #1e293b;
}

.sv-detail-section {
    margin-bottom: 1.25rem;
}

.sv-detail-section h4 {
    margin: 0 0 0.5rem;
    font-size: 0.85rem;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.sv-detail-text-box {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    color: #334155;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
}

.sv-hashtags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
}

.sv-hashtag {
    background: #eff6ff;
    color: #1d4ed8;
    padding: 0.2rem 0.5rem;
    border-radius: 4px;
    font-size: 0.8rem;
    font-weight: 500;
}

/* ── Video player ── */
.sv-video-container {
    border-radius: 10px;
    overflow: hidden;
    background: #000;
    max-width: 100%;
}

.sv-video-player {
    width: 100%;
    max-height: 400px;
    display: block;
}

.sv-video-duration {
    margin: 0.5rem 0 0;
    font-size: 0.8rem;
    color: #64748b;
}

.sv-permalink {
    color: #2563eb;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
}

.sv-permalink:hover {
    text-decoration: underline;
}

.sv-json-box {
    background: #1e293b;
    color: #e2e8f0;
    border-radius: 8px;
    padding: 1rem;
    font-size: 0.8rem;
    overflow-x: auto;
    white-space: pre;
    line-height: 1.5;
    max-height: 200px;
    overflow-y: auto;
}

/* ── Responsive ── */
@media (max-width: 1024px) {
    .sv-stats-row {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .sv-stats-row {
        grid-template-columns: repeat(2, 1fr);
    }

    .sv-detail-grid {
        grid-template-columns: 1fr;
    }

    .sv-filters {
        flex-direction: column;
    }
}

@media (max-width: 480px) {
    .sv-stats-row {
        grid-template-columns: 1fr;
    }

    .sv-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
    }
}

/* ── Retry Button (table + detail modal) ── */
.sv-btn-retry {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.35rem 0.75rem;
    background: #fff7ed;
    border: 1px solid #f97316;
    border-radius: 6px;
    color: #c2410c;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, transform 0.1s;
    white-space: nowrap;
}

.sv-btn-retry:hover:not(:disabled) {
    background: #ffedd5;
    transform: translateY(-1px);
}

.sv-btn-retry:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ── Retry Confirm Modal ── */
.sv-retry-modal {
    background: #fff;
    border-radius: 14px;
    padding: 1.75rem;
    width: 90%;
    max-width: 480px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    animation: sv-modal-in 0.2s ease-out;
}

.sv-retry-modal h3 {
    margin: 0 0 1rem;
    font-size: 1.15rem;
    color: #1e293b;
}

.sv-retry-detail {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 1rem;
    margin-bottom: 1rem;
}

.sv-retry-detail p {
    margin: 0 0 0.5rem;
    font-size: 0.9rem;
    color: #334155;
}

.sv-retry-label {
    font-size: 0.75rem;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-weight: 600;
}

.sv-retry-platforms {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 0.75rem;
}

.sv-retry-platform-tag {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.2rem 0.6rem;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 12px;
    font-size: 0.78rem;
    color: #1d4ed8;
    font-weight: 500;
    text-transform: capitalize;
}

.sv-retry-error-box {
    margin-top: 0.5rem;
}

.sv-retry-error-text {
    margin: 0.25rem 0 0;
    font-size: 0.83rem;
    color: #dc2626;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 6px;
    padding: 0.5rem 0.75rem;
    word-break: break-word;
}

.sv-retry-platform-results {
    margin-top: 0.75rem;
}

.sv-retry-result-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 0;
    font-size: 0.83rem;
    border-bottom: 1px solid #f1f5f9;
}

.sv-retry-result-row:last-child {
    border-bottom: none;
}

.sv-result-ok {
    color: #16a34a;
    font-weight: 600;
}

.sv-result-fail {
    color: #dc2626;
    font-weight: 600;
}

.sv-retry-warning {
    font-size: 0.83rem;
    color: #92400e;
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 6px;
    padding: 0.5rem 0.75rem;
    margin-bottom: 1rem;
}

.sv-retry-actions {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
}

.sv-btn-retry-confirm {
    padding: 0.5rem 1.25rem;
    background: #f97316;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
}

.sv-btn-retry-confirm:hover:not(:disabled) {
    background: #ea580c;
}

.sv-btn-retry-confirm:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.sv-btn-retry-cancel {
    padding: 0.5rem 1.25rem;
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    color: #475569;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s;
}

.sv-btn-retry-cancel:hover {
    background: #e2e8f0;
}

/* ── Retry Result Toast ── */
.sv-retry-toast {
    position: fixed;
    bottom: 1.5rem;
    right: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1.25rem;
    border-radius: 10px;
    font-size: 0.88rem;
    font-weight: 500;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
    z-index: 10000;
    animation: sv-toast-in 0.3s ease-out;
}

.sv-retry-toast-success {
    background: #ecfdf5;
    border: 1px solid #a7f3d0;
    color: #065f46;
}

.sv-retry-toast-error {
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #991b1b;
}

.sv-retry-toast-close {
    background: none;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    color: inherit;
    padding: 0 0.25rem;
    opacity: 0.7;
}

.sv-retry-toast-close:hover {
    opacity: 1;
}

@keyframes sv-toast-in {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}


/* ══════════════════════════════════════════
   BULK SELECTION & ACTIONS
   ══════════════════════════════════════════ */

/* Checkbox columns */
.sv-th-checkbox,
.sv-cell-checkbox {
    width: 40px;
    min-width: 40px;
    max-width: 40px;
    text-align: center;
    padding: 8px 4px;
}

.sv-th-checkbox input[type="checkbox"],
.sv-cell-checkbox input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: var(--primary, #6366f1);
}

/* Selected row highlight */
.sv-row-selected {
    background-color: rgba(99, 102, 241, 0.08) !important;
}

.sv-row-selected:hover {
    background-color: rgba(99, 102, 241, 0.14) !important;
}

/* Bulk action bar */
.sv-bulk-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 20px;
    margin-bottom: 12px;
    background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
    border: 1px solid #c7d2fe;
    border-radius: 10px;
    animation: sv-bulk-bar-in 0.2s ease-out;
}

@keyframes sv-bulk-bar-in {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.sv-bulk-count {
    font-weight: 600;
    color: #4338ca;
    font-size: 0.9rem;
    white-space: nowrap;
}

.sv-bulk-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.sv-btn-bulk-retry {
    padding: 7px 14px;
    border: none;
    border-radius: 6px;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    background: #3b82f6;
    color: #fff;
    transition: background 0.15s;
}

.sv-btn-bulk-retry:hover:not(:disabled) {
    background: #2563eb;
}

.sv-btn-bulk-delete {
    padding: 7px 14px;
    border: none;
    border-radius: 6px;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    background: #ef4444;
    color: #fff;
    transition: background 0.15s;
}

.sv-btn-bulk-delete:hover:not(:disabled) {
    background: #dc2626;
}

.sv-btn-bulk-clear {
    padding: 7px 14px;
    border: 1px solid #a5b4fc;
    border-radius: 6px;
    font-size: 0.82rem;
    font-weight: 500;
    cursor: pointer;
    background: transparent;
    color: #4338ca;
    transition: all 0.15s;
}

.sv-btn-bulk-clear:hover {
    background: rgba(99, 102, 241, 0.1);
}

.sv-btn-bulk-retry:disabled,
.sv-btn-bulk-delete:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Bulk confirm modal */
.sv-bulk-modal {
    background: #fff;
    border-radius: 16px;
    padding: 28px 32px;
    max-width: 480px;
    width: 90vw;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    animation: sv-modal-in 0.2s ease-out;
}

.sv-bulk-modal h3 {
    margin: 0 0 16px;
    font-size: 1.15rem;
    color: #1e293b;
}

.sv-bulk-modal-desc {
    color: #475569;
    font-size: 0.92rem;
    line-height: 1.5;
    margin: 0 0 12px;
}

.sv-bulk-modal-warning {
    color: #b45309;
    font-size: 0.85rem;
    background: #fef3c7;
    padding: 10px 14px;
    border-radius: 8px;
    margin: 0 0 16px;
    line-height: 1.4;
}

.sv-bulk-modal-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 20px;
}

.sv-btn-bulk-confirm-delete {
    padding: 9px 20px;
    border: none;
    border-radius: 8px;
    font-size: 0.88rem;
    font-weight: 600;
    cursor: pointer;
    background: #ef4444;
    color: #fff;
    transition: background 0.15s;
}

.sv-btn-bulk-confirm-delete:hover:not(:disabled) {
    background: #dc2626;
}

.sv-btn-bulk-confirm-retry {
    padding: 9px 20px;
    border: none;
    border-radius: 8px;
    font-size: 0.88rem;
    font-weight: 600;
    cursor: pointer;
    background: #3b82f6;
    color: #fff;
    transition: background 0.15s;
}

.sv-btn-bulk-confirm-retry:hover:not(:disabled) {
    background: #2563eb;
}

.sv-btn-bulk-cancel {
    padding: 9px 20px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 0.88rem;
    font-weight: 500;
    cursor: pointer;
    background: #fff;
    color: #64748b;
    transition: all 0.15s;
}

.sv-btn-bulk-cancel:hover:not(:disabled) {
    background: #f8fafc;
    border-color: #94a3b8;
}

.sv-btn-bulk-confirm-delete:disabled,
.sv-btn-bulk-confirm-retry:disabled,
.sv-btn-bulk-cancel:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
/* ── Reschedule button + modal (superadmin) ── */
.sv-btn-reschedule {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.35rem 0.75rem;
    background: #eff6ff;
    border: 1px solid #3b82f6;
    border-radius: 6px;
    color: #1d4ed8;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, transform 0.1s;
    white-space: nowrap;
}

.sv-btn-reschedule:hover:not(:disabled) {
    background: #dbeafe;
    transform: translateY(-1px);
}

.sv-btn-reschedule:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.sv-reschedule-modal {
    background: #ffffff;
    border-radius: 12px;
    max-width: 480px;
    width: 100%;
    padding: 1.5rem;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}

.sv-reschedule-modal h3 {
    margin: 0 0 1rem;
    font-size: 1.05rem;
    font-weight: 700;
    color: #1e293b;
}

.sv-reschedule-info {
    background: #f8fafc;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    margin-bottom: 1.25rem;
    font-size: 0.85rem;
    color: #334155;
}

.sv-reschedule-info p {
    margin: 0.25rem 0;
}

.sv-reschedule-current {
    color: #475569;
}

.sv-reschedule-label {
    display: block;
    font-size: 0.85rem;
    font-weight: 600;
    color: #334155;
    margin-bottom: 1.25rem;
}

.sv-reschedule-input {
    display: block;
    width: 100%;
    margin-top: 0.4rem;
    padding: 0.55rem 0.75rem;
    border: 1.5px solid #cbd5e1;
    border-radius: 8px;
    font-size: 0.9rem;
    color: #1e293b;
    background: #fff;
    transition: border-color 0.15s, box-shadow 0.15s;
}

.sv-reschedule-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.sv-reschedule-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
}

.sv-btn-reschedule-confirm {
    padding: 0.55rem 1.1rem;
    border-radius: 8px;
    border: none;
    background: #2563eb;
    color: #fff;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
}

.sv-btn-reschedule-confirm:hover:not(:disabled) {
    background: #1d4ed8;
}

.sv-btn-reschedule-confirm:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/ScheduledVideos.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;IACI,UAAU;AACd;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;;IAEI;;QAEI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;AACJ;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA,wBAAwB;AACxB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI;;QAEI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,YAAY;IAChB;AACJ;;AAEA,8CAA8C;AAC9C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,2CAA2C;IAC3C,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;IAC1C,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;;AAGA;;+CAE+C;;AAE/C,qBAAqB;AACrB;;IAEI,WAAW;IACX,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qCAAqC;AACzC;;AAEA,2BAA2B;AAC3B;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,6DAA6D;IAC7D,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,2CAA2C;IAC3C,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;;IAGI,YAAY;IACZ,mBAAmB;AACvB;AACA,iDAAiD;AACjD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":["/* ScheduledVideos admin page styles */\n\n.scheduled-videos-page {\n    padding: 0;\n}\n\n/* ── Header ── */\n.sv-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n}\n\n.sv-header-left {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.sv-header h1 {\n    margin: 0;\n}\n\n.sv-btn-refresh {\n    padding: 0.5rem 1rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    background: #fff;\n    cursor: pointer;\n    font-size: 0.85rem;\n    transition: background 0.15s;\n}\n\n.sv-btn-refresh:hover {\n    background: #f1f5f9;\n}\n\n/* ── Live indicator ── */\n.sv-live-indicator {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.25rem 0.6rem;\n    background: #ecfdf5;\n    border: 1px solid #a7f3d0;\n    border-radius: 20px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #065f46;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.sv-live-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #10b981;\n    animation: sv-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes sv-pulse {\n\n    0%,\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 0.5;\n        transform: scale(0.8);\n    }\n}\n\n/* ── Stats row ── */\n.sv-stats-row {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.sv-stat-card {\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 1.1rem;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n}\n\n.sv-stat-value {\n    font-size: 1.7rem;\n    font-weight: 700;\n    color: #1e293b;\n}\n\n.sv-stat-label {\n    font-size: 0.75rem;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.sv-stat-published .sv-stat-value {\n    color: #16a34a;\n}\n\n.sv-stat-pipeline .sv-stat-value {\n    color: #2563eb;\n}\n\n.sv-stat-failed .sv-stat-value {\n    color: #dc2626;\n}\n\n.sv-stat-today .sv-stat-value {\n    color: #7c3aed;\n}\n\n/* ── Filters ── */\n.sv-filters {\n    display: flex;\n    gap: 0.75rem;\n    margin-bottom: 1.25rem;\n    flex-wrap: wrap;\n    align-items: flex-end;\n}\n\n.sv-select {\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    background: #fff;\n    min-width: 180px;\n}\n\n.sv-search-input {\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    background: #fff;\n    min-width: 260px;\n    flex: 1 1 260px;\n}\n\n.sv-search-input:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n.sv-date-filters {\n    display: flex;\n    gap: 0.5rem;\n    align-items: flex-end;\n}\n\n.sv-date-label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    font-size: 0.75rem;\n    color: #64748b;\n}\n\n.sv-date-label input[type=\"date\"] {\n    padding: 0.45rem 0.6rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 0.85rem;\n}\n\n/* ── Table ── */\n.sv-table-container {\n    background: #fff;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n    overflow-x: auto;\n}\n\n.sv-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.88rem;\n}\n\n.sv-table thead th {\n    text-align: left;\n    padding: 0.75rem 0.85rem;\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n    color: #475569;\n    font-weight: 600;\n    font-size: 0.78rem;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    white-space: nowrap;\n}\n\n.sv-th-sortable {\n    cursor: pointer;\n    user-select: none;\n}\n\n.sv-th-sortable:hover {\n    color: #1e293b;\n}\n\n.sv-table tbody td {\n    padding: 0.65rem 0.85rem;\n    border-bottom: 1px solid #f1f5f9;\n    vertical-align: middle;\n}\n\n.sv-row-clickable {\n    cursor: pointer;\n    transition: background 0.12s;\n}\n\n.sv-row-clickable:hover {\n    background: #f8fafc;\n}\n\n.sv-cell-id {\n    font-weight: 600;\n    color: #64748b;\n    font-size: 0.8rem;\n}\n\n.sv-cell-script {\n    max-width: 200px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #475569;\n    font-size: 0.85rem;\n}\n\n.sv-user-cell {\n    display: flex;\n    flex-direction: column;\n    gap: 0.1rem;\n}\n\n.sv-user-email {\n    font-size: 0.85rem;\n    color: #475569;\n}\n\n.sv-ig-username {\n    font-size: 0.75rem;\n    color: #94a3b8;\n}\n\n.sv-has-video {\n    font-size: 1.1rem;\n}\n\n.sv-no-video {\n    color: #cbd5e1;\n}\n\n/* ── Platform icons in table ── */\n.sv-platforms-cell {\n    display: flex;\n    gap: 0.35rem;\n    align-items: center;\n}\n\n.sv-platform-icon {\n    font-size: 1rem;\n    text-decoration: none;\n    opacity: 0.5;\n    transition: opacity 0.15s;\n}\n\n.sv-platform-icon.sv-platform-ok {\n    opacity: 1;\n}\n\n.sv-platform-icon.sv-platform-fail {\n    opacity: 0.8;\n    filter: grayscale(0.6);\n}\n\na.sv-platform-icon:hover {\n    opacity: 1;\n    transform: scale(1.15);\n}\n\n/* ── Status badges ── */\n.sv-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    padding: 0.2rem 0.55rem;\n    border-radius: 6px;\n    font-size: 0.73rem;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.sv-badge-icon {\n    font-size: 0.7rem;\n}\n\n.sv-status-draft {\n    background: #f1f5f9;\n    color: #475569;\n}\n\n.sv-status-pipeline {\n    background: #dbeafe;\n    color: #1e40af;\n    animation: sv-badge-pulse 2s ease-in-out infinite;\n}\n\n.sv-status-pending {\n    background: #fef3c7;\n    color: #92400e;\n}\n\n.sv-status-approved {\n    background: #e0f2fe;\n    color: #0c4a6e;\n}\n\n.sv-status-queued {\n    background: #fef3c7;\n    color: #78350f;\n}\n\n.sv-status-published {\n    background: #d1fae5;\n    color: #065f46;\n}\n\n.sv-status-partial {\n    background: #fef9c3;\n    color: #713f12;\n}\n\n.sv-status-failed {\n    background: #fee2e2;\n    color: #991b1b;\n}\n\n@keyframes sv-badge-pulse {\n\n    0%,\n    100% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.7;\n    }\n}\n\n/* ── Pagination ── */\n.sv-pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    margin-top: 1.25rem;\n}\n\n.sv-pagination button {\n    padding: 0.4rem 0.9rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    font-size: 0.85rem;\n}\n\n.sv-pagination button:disabled {\n    opacity: 0.45;\n    cursor: default;\n}\n\n.sv-page-info {\n    font-size: 0.85rem;\n    color: #64748b;\n}\n\n/* ── States ── */\n.sv-loading,\n.sv-empty {\n    text-align: center;\n    padding: 3rem 1rem;\n    color: #64748b;\n    font-size: 0.95rem;\n}\n\n.sv-error {\n    background: #fef2f2;\n    color: #b91c1c;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    font-size: 0.9rem;\n}\n\n/* ── Detail Modal ── */\n.sv-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    z-index: 1000;\n    padding: 2rem 1rem;\n    overflow-y: auto;\n}\n\n.sv-modal-card {\n    background: #fff;\n    border-radius: 12px;\n    width: 100%;\n    max-width: 700px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n    margin: auto;\n}\n\n.sv-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.25rem 1.5rem;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.sv-modal-header h2 {\n    margin: 0;\n    font-size: 1.1rem;\n}\n\n.sv-modal-close {\n    background: none;\n    border: none;\n    font-size: 1.2rem;\n    cursor: pointer;\n    color: #64748b;\n    padding: 0.25rem;\n}\n\n.sv-modal-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.sv-btn-delete {\n    background: #fef2f2;\n    color: #dc2626;\n    border: 1px solid #fecaca;\n    border-radius: 6px;\n    padding: 0.35rem 0.75rem;\n    font-size: 0.82rem;\n    cursor: pointer;\n    transition: background 0.2s, border-color 0.2s;\n}\n\n.sv-btn-delete:hover {\n    background: #fee2e2;\n    border-color: #f87171;\n}\n\n.sv-delete-confirm {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.sv-delete-confirm-text {\n    font-size: 0.8rem;\n    color: #dc2626;\n    font-weight: 500;\n}\n\n.sv-btn-delete-yes {\n    background: #dc2626;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    padding: 0.3rem 0.75rem;\n    font-size: 0.8rem;\n    cursor: pointer;\n    font-weight: 600;\n    transition: background 0.2s;\n}\n\n.sv-btn-delete-yes:hover {\n    background: #b91c1c;\n}\n\n.sv-btn-delete-yes:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.sv-btn-delete-no {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #e2e8f0;\n    border-radius: 5px;\n    padding: 0.3rem 0.75rem;\n    font-size: 0.8rem;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.sv-btn-delete-no:hover {\n    background: #e2e8f0;\n}\n\n.sv-modal-body {\n    padding: 1.5rem;\n}\n\n.sv-detail-status-row {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 1.25rem;\n    flex-wrap: wrap;\n}\n\n.sv-detail-status-msg {\n    font-size: 0.85rem;\n    color: #64748b;\n    font-style: italic;\n}\n\n.sv-detail-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.sv-detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n}\n\n.sv-detail-item label {\n    font-size: 0.72rem;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.sv-detail-item span {\n    font-size: 0.9rem;\n    color: #1e293b;\n}\n\n.sv-detail-section {\n    margin-bottom: 1.25rem;\n}\n\n.sv-detail-section h4 {\n    margin: 0 0 0.5rem;\n    font-size: 0.85rem;\n    color: #475569;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.sv-detail-text-box {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 0.75rem 1rem;\n    font-size: 0.9rem;\n    color: #334155;\n    line-height: 1.5;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.sv-hashtags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.4rem;\n}\n\n.sv-hashtag {\n    background: #eff6ff;\n    color: #1d4ed8;\n    padding: 0.2rem 0.5rem;\n    border-radius: 4px;\n    font-size: 0.8rem;\n    font-weight: 500;\n}\n\n/* ── Video player ── */\n.sv-video-container {\n    border-radius: 10px;\n    overflow: hidden;\n    background: #000;\n    max-width: 100%;\n}\n\n.sv-video-player {\n    width: 100%;\n    max-height: 400px;\n    display: block;\n}\n\n.sv-video-duration {\n    margin: 0.5rem 0 0;\n    font-size: 0.8rem;\n    color: #64748b;\n}\n\n.sv-permalink {\n    color: #2563eb;\n    text-decoration: none;\n    font-size: 0.9rem;\n    font-weight: 500;\n}\n\n.sv-permalink:hover {\n    text-decoration: underline;\n}\n\n.sv-json-box {\n    background: #1e293b;\n    color: #e2e8f0;\n    border-radius: 8px;\n    padding: 1rem;\n    font-size: 0.8rem;\n    overflow-x: auto;\n    white-space: pre;\n    line-height: 1.5;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n/* ── Responsive ── */\n@media (max-width: 1024px) {\n    .sv-stats-row {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .sv-stats-row {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .sv-detail-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .sv-filters {\n        flex-direction: column;\n    }\n}\n\n@media (max-width: 480px) {\n    .sv-stats-row {\n        grid-template-columns: 1fr;\n    }\n\n    .sv-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.75rem;\n    }\n}\n\n/* ── Retry Button (table + detail modal) ── */\n.sv-btn-retry {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    padding: 0.35rem 0.75rem;\n    background: #fff7ed;\n    border: 1px solid #f97316;\n    border-radius: 6px;\n    color: #c2410c;\n    font-size: 0.78rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s, transform 0.1s;\n    white-space: nowrap;\n}\n\n.sv-btn-retry:hover:not(:disabled) {\n    background: #ffedd5;\n    transform: translateY(-1px);\n}\n\n.sv-btn-retry:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* ── Retry Confirm Modal ── */\n.sv-retry-modal {\n    background: #fff;\n    border-radius: 14px;\n    padding: 1.75rem;\n    width: 90%;\n    max-width: 480px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n    animation: sv-modal-in 0.2s ease-out;\n}\n\n.sv-retry-modal h3 {\n    margin: 0 0 1rem;\n    font-size: 1.15rem;\n    color: #1e293b;\n}\n\n.sv-retry-detail {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 1rem;\n    margin-bottom: 1rem;\n}\n\n.sv-retry-detail p {\n    margin: 0 0 0.5rem;\n    font-size: 0.9rem;\n    color: #334155;\n}\n\n.sv-retry-label {\n    font-size: 0.75rem;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    font-weight: 600;\n}\n\n.sv-retry-platforms {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin-bottom: 0.75rem;\n}\n\n.sv-retry-platform-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.25rem;\n    padding: 0.2rem 0.6rem;\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    border-radius: 12px;\n    font-size: 0.78rem;\n    color: #1d4ed8;\n    font-weight: 500;\n    text-transform: capitalize;\n}\n\n.sv-retry-error-box {\n    margin-top: 0.5rem;\n}\n\n.sv-retry-error-text {\n    margin: 0.25rem 0 0;\n    font-size: 0.83rem;\n    color: #dc2626;\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    border-radius: 6px;\n    padding: 0.5rem 0.75rem;\n    word-break: break-word;\n}\n\n.sv-retry-platform-results {\n    margin-top: 0.75rem;\n}\n\n.sv-retry-result-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.3rem 0;\n    font-size: 0.83rem;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.sv-retry-result-row:last-child {\n    border-bottom: none;\n}\n\n.sv-result-ok {\n    color: #16a34a;\n    font-weight: 600;\n}\n\n.sv-result-fail {\n    color: #dc2626;\n    font-weight: 600;\n}\n\n.sv-retry-warning {\n    font-size: 0.83rem;\n    color: #92400e;\n    background: #fffbeb;\n    border: 1px solid #fde68a;\n    border-radius: 6px;\n    padding: 0.5rem 0.75rem;\n    margin-bottom: 1rem;\n}\n\n.sv-retry-actions {\n    display: flex;\n    gap: 0.75rem;\n    justify-content: flex-end;\n}\n\n.sv-btn-retry-confirm {\n    padding: 0.5rem 1.25rem;\n    background: #f97316;\n    border: none;\n    border-radius: 8px;\n    color: #fff;\n    font-size: 0.85rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.sv-btn-retry-confirm:hover:not(:disabled) {\n    background: #ea580c;\n}\n\n.sv-btn-retry-confirm:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.sv-btn-retry-cancel {\n    padding: 0.5rem 1.25rem;\n    background: #f1f5f9;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    color: #475569;\n    font-size: 0.85rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.sv-btn-retry-cancel:hover {\n    background: #e2e8f0;\n}\n\n/* ── Retry Result Toast ── */\n.sv-retry-toast {\n    position: fixed;\n    bottom: 1.5rem;\n    right: 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem 1.25rem;\n    border-radius: 10px;\n    font-size: 0.88rem;\n    font-weight: 500;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n    z-index: 10000;\n    animation: sv-toast-in 0.3s ease-out;\n}\n\n.sv-retry-toast-success {\n    background: #ecfdf5;\n    border: 1px solid #a7f3d0;\n    color: #065f46;\n}\n\n.sv-retry-toast-error {\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    color: #991b1b;\n}\n\n.sv-retry-toast-close {\n    background: none;\n    border: none;\n    font-size: 1rem;\n    cursor: pointer;\n    color: inherit;\n    padding: 0 0.25rem;\n    opacity: 0.7;\n}\n\n.sv-retry-toast-close:hover {\n    opacity: 1;\n}\n\n@keyframes sv-toast-in {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n/* ══════════════════════════════════════════\n   BULK SELECTION & ACTIONS\n   ══════════════════════════════════════════ */\n\n/* Checkbox columns */\n.sv-th-checkbox,\n.sv-cell-checkbox {\n    width: 40px;\n    min-width: 40px;\n    max-width: 40px;\n    text-align: center;\n    padding: 8px 4px;\n}\n\n.sv-th-checkbox input[type=\"checkbox\"],\n.sv-cell-checkbox input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    accent-color: var(--primary, #6366f1);\n}\n\n/* Selected row highlight */\n.sv-row-selected {\n    background-color: rgba(99, 102, 241, 0.08) !important;\n}\n\n.sv-row-selected:hover {\n    background-color: rgba(99, 102, 241, 0.14) !important;\n}\n\n/* Bulk action bar */\n.sv-bulk-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 12px 20px;\n    margin-bottom: 12px;\n    background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);\n    border: 1px solid #c7d2fe;\n    border-radius: 10px;\n    animation: sv-bulk-bar-in 0.2s ease-out;\n}\n\n@keyframes sv-bulk-bar-in {\n    from {\n        opacity: 0;\n        transform: translateY(-8px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.sv-bulk-count {\n    font-weight: 600;\n    color: #4338ca;\n    font-size: 0.9rem;\n    white-space: nowrap;\n}\n\n.sv-bulk-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.sv-btn-bulk-retry {\n    padding: 7px 14px;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.82rem;\n    font-weight: 600;\n    cursor: pointer;\n    background: #3b82f6;\n    color: #fff;\n    transition: background 0.15s;\n}\n\n.sv-btn-bulk-retry:hover:not(:disabled) {\n    background: #2563eb;\n}\n\n.sv-btn-bulk-delete {\n    padding: 7px 14px;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.82rem;\n    font-weight: 600;\n    cursor: pointer;\n    background: #ef4444;\n    color: #fff;\n    transition: background 0.15s;\n}\n\n.sv-btn-bulk-delete:hover:not(:disabled) {\n    background: #dc2626;\n}\n\n.sv-btn-bulk-clear {\n    padding: 7px 14px;\n    border: 1px solid #a5b4fc;\n    border-radius: 6px;\n    font-size: 0.82rem;\n    font-weight: 500;\n    cursor: pointer;\n    background: transparent;\n    color: #4338ca;\n    transition: all 0.15s;\n}\n\n.sv-btn-bulk-clear:hover {\n    background: rgba(99, 102, 241, 0.1);\n}\n\n.sv-btn-bulk-retry:disabled,\n.sv-btn-bulk-delete:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Bulk confirm modal */\n.sv-bulk-modal {\n    background: #fff;\n    border-radius: 16px;\n    padding: 28px 32px;\n    max-width: 480px;\n    width: 90vw;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n    animation: sv-modal-in 0.2s ease-out;\n}\n\n.sv-bulk-modal h3 {\n    margin: 0 0 16px;\n    font-size: 1.15rem;\n    color: #1e293b;\n}\n\n.sv-bulk-modal-desc {\n    color: #475569;\n    font-size: 0.92rem;\n    line-height: 1.5;\n    margin: 0 0 12px;\n}\n\n.sv-bulk-modal-warning {\n    color: #b45309;\n    font-size: 0.85rem;\n    background: #fef3c7;\n    padding: 10px 14px;\n    border-radius: 8px;\n    margin: 0 0 16px;\n    line-height: 1.4;\n}\n\n.sv-bulk-modal-actions {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n    margin-top: 20px;\n}\n\n.sv-btn-bulk-confirm-delete {\n    padding: 9px 20px;\n    border: none;\n    border-radius: 8px;\n    font-size: 0.88rem;\n    font-weight: 600;\n    cursor: pointer;\n    background: #ef4444;\n    color: #fff;\n    transition: background 0.15s;\n}\n\n.sv-btn-bulk-confirm-delete:hover:not(:disabled) {\n    background: #dc2626;\n}\n\n.sv-btn-bulk-confirm-retry {\n    padding: 9px 20px;\n    border: none;\n    border-radius: 8px;\n    font-size: 0.88rem;\n    font-weight: 600;\n    cursor: pointer;\n    background: #3b82f6;\n    color: #fff;\n    transition: background 0.15s;\n}\n\n.sv-btn-bulk-confirm-retry:hover:not(:disabled) {\n    background: #2563eb;\n}\n\n.sv-btn-bulk-cancel {\n    padding: 9px 20px;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    font-size: 0.88rem;\n    font-weight: 500;\n    cursor: pointer;\n    background: #fff;\n    color: #64748b;\n    transition: all 0.15s;\n}\n\n.sv-btn-bulk-cancel:hover:not(:disabled) {\n    background: #f8fafc;\n    border-color: #94a3b8;\n}\n\n.sv-btn-bulk-confirm-delete:disabled,\n.sv-btn-bulk-confirm-retry:disabled,\n.sv-btn-bulk-cancel:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n/* ── Reschedule button + modal (superadmin) ── */\n.sv-btn-reschedule {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    padding: 0.35rem 0.75rem;\n    background: #eff6ff;\n    border: 1px solid #3b82f6;\n    border-radius: 6px;\n    color: #1d4ed8;\n    font-size: 0.78rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s, transform 0.1s;\n    white-space: nowrap;\n}\n\n.sv-btn-reschedule:hover:not(:disabled) {\n    background: #dbeafe;\n    transform: translateY(-1px);\n}\n\n.sv-btn-reschedule:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.sv-reschedule-modal {\n    background: #ffffff;\n    border-radius: 12px;\n    max-width: 480px;\n    width: 100%;\n    padding: 1.5rem;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\n}\n\n.sv-reschedule-modal h3 {\n    margin: 0 0 1rem;\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: #1e293b;\n}\n\n.sv-reschedule-info {\n    background: #f8fafc;\n    border-radius: 8px;\n    padding: 0.75rem 1rem;\n    margin-bottom: 1.25rem;\n    font-size: 0.85rem;\n    color: #334155;\n}\n\n.sv-reschedule-info p {\n    margin: 0.25rem 0;\n}\n\n.sv-reschedule-current {\n    color: #475569;\n}\n\n.sv-reschedule-label {\n    display: block;\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #334155;\n    margin-bottom: 1.25rem;\n}\n\n.sv-reschedule-input {\n    display: block;\n    width: 100%;\n    margin-top: 0.4rem;\n    padding: 0.55rem 0.75rem;\n    border: 1.5px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    color: #1e293b;\n    background: #fff;\n    transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.sv-reschedule-input:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.sv-reschedule-actions {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: flex-end;\n}\n\n.sv-btn-reschedule-confirm {\n    padding: 0.55rem 1.1rem;\n    border-radius: 8px;\n    border: none;\n    background: #2563eb;\n    color: #fff;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.sv-btn-reschedule-confirm:hover:not(:disabled) {\n    background: #1d4ed8;\n}\n\n.sv-btn-reschedule-confirm:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
